import Cookies from "js-cookie";
// export function setCookie(cname, cvalue, expires = 30) {
//   // let expires = "";
//   // const date = new Date();
//   // date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
//   // expires = date.toUTCString();
//   return Cookies.set(cname, cvalue, { expires, path: "/" });
// }
export function setCookie1(cname, cvalue) {
  let expires = "";
  const date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  expires = "; expires=" + date.toUTCString();
  return cname + "=" + cvalue + expires + "; path=/";
}
